export default __webpack_public_path__ + "static/media/allocate_subject.e5823845.png";